const state = {
    // 用户是否已经上传银行卡
    isUpBank: false,
    // 用户上传银行卡信息
    bankData: null,
    // 用户是否已经上传身份证
    isUpId: false,
    // 用户上传身份证信息
    idData: null,
    // 银行卡类型列表
    bankTypeData: [],
    // 车主认证信息
    verificationInfo: {},
    // 车主银行卡列表
    bankList: [],
    // 用户是否选中银行卡
    isBank: false,
    // 当前选中银行卡
    selectBank: null,
    // 最新提现记录
    moneyRecord: null,
    // 新增的银行卡号
    newBankCardNumber: ''
}
export default state